import React, { useState, useEffect, useRef, useContext, useCallback } from 'react';
import { connect } from 'react-redux';
import GameSummary from './GameSummary';
import { fetchGames } from '../util/api/game';
import { ChessSocialContext } from '../util/ChessSocialContext';
import { filterGameData } from '../util/ClipCall';
import mansalva from '../images/Mansalva/Mansalva-Regular.ttf';
import iPhone from '../images/iPhone.png';
import { firestore } from '../firebase';
import { collection, addDoc, Timestamp, doc, getDoc, setDoc, query, where, getDocs, orderBy } from "firebase/firestore";
import { getAuth } from "firebase/auth";
import crownGold from '../images/CrownGold.png';

// Add a style block to define the font-face
const MansalvaFontStyle = () => {
  return (
    <style>
      {`
        @font-face {
          font-family: 'Mansalva';
          src: url(${mansalva}) format('truetype');
          font-weight: normal;
          font-style: normal;
          font-display: swap;
        }
      `}
    </style>
  );
};

// Update YouTube videos array with proper parameters
const YOUTUBE_VIDEOS = [
  "https://www.youtube.com/embed/5bcT__RV384?controls=0&showinfo=0&rel=0&enablejsapi=1&origin=http://localhost:3000&mute=1&modestbranding=1",
  "https://www.youtube.com/embed/0nY54s1Mk6s?autoplay=1&controls=0&showinfo=0&rel=0&enablejsapi=1&origin=http://localhost:3000&mute=1&playlist=0nY54s1Mk6s&loop=1&modestbranding=1",
  "https://www.youtube.com/embed/K3rInl31-94?controls=0&showinfo=0&rel=0&enablejsapi=1&origin=http://localhost:3000&mute=1&modestbranding=1"
];

const PremiumPortal = (props) => {
  const [activeTab, setActiveTab] = useState('features');
  const [games, setGames] = useState([]);
  const scrollContainerRef = useRef(null);
  const { isSidebarCollapsed } = useContext(ChessSocialContext);
  const [showModal, setShowModal] = useState(false);
  const [selectedGame, setSelectedGame] = useState(null);
  const [showFeedbackForm, setShowFeedbackForm] = useState(false);
  const [feedbackMessage, setFeedbackMessage] = useState('');
  const [isSubmittingFeedback, setIsSubmittingFeedback] = useState(false);
  const [successMessage, setSuccessMessage] = useState('');
  const [error, setError] = useState('');
  const [isLoading, setIsLoading] = useState(false);

  // Set active tab based on URL parameters
  useEffect(() => {
    // Check for tab parameter in URL
    const queryParams = new URLSearchParams(window.location.search);
    const tabParam = queryParams.get('tab');

    // If tab parameter exists and is valid, set it as active tab
    if (tabParam && (tabParam === 'features' || tabParam === 'transform')) {
      setActiveTab(tabParam);

      // Clean the URL by removing the tab parameter
      const cleanUrl = window.location.pathname;
      window.history.replaceState({}, document.title, cleanUrl);
    }
  }, []);

  // Add a style element for the YouTube iframe
  useEffect(() => {
    // Create a style element to target the YouTube iframe
    const styleEl = document.createElement('style');
    styleEl.textContent = `
      .youtube-player-container {
        display: flex;
        justify-content: center;
        align-items: center;
        overflow: hidden;
        border-radius: 25px;
        background-color: black;
        width: 83% !important;
        transform: translateX(13px);
      }
      
      .youtube-player-container iframe {
        border-radius: 25px;
        width: 98% !important;
        height: 98% !important;
      }
    `;
    document.head.appendChild(styleEl);

    return () => {
      document.head.removeChild(styleEl);
    };
  }, []);

  const handleTabClick = (tab) => {
    setActiveTab(tab);
  };

  // Handle ellipsis button click
  const handleEllipsisClick = (game, e) => {
    e.stopPropagation(); // Prevent triggering the game click

    if (!game || !game.id) {
      console.error("Invalid game data:", game);
      setError('Invalid game data');
      setTimeout(() => setError(''), 3000);
      return;
    }

    // Filter and log the game data
    const filteredData = filterGameData(game);
    

    // Set the selected game and show the modal
    setSelectedGame(filteredData);
    setShowModal(true);
  };

  // Handle modal confirm action
  const handleConfirmConversion = () => {
    if (!selectedGame || !selectedGame.id) {
      setError('No game selected or invalid game data.');
      setTimeout(() => setError(''), 3000);
      return;
    }

    // Get the current user from Firebase Auth
    const auth = getAuth();
    const currentUser = auth.currentUser;

    if (!currentUser) {
      setError('You must be logged in to convert games.');
      setTimeout(() => setError(''), 3000);
      setShowModal(false);
      return;
    }

    const gameId = selectedGame.id;

    // Accessing specific data from the already filtered game
    const arrowsAndSquares = selectedGame.arrowsAndSquares || [];
    const originalMoves = selectedGame.originalMoves || [];
    const pgn = selectedGame.pgn || '';
    const videoTitle = selectedGame.videoTitle || 'ChessThread.com';
    const gameFen = selectedGame.fen || ''; // Extract FEN from the game data

    const transformedData = {
      takeScreenShot: false,
      videoUrl: '',
      isCapturingComplete: false,
      moves: originalMoves.map((move) => move.notation),
      frameRate: 1,
      startFrame: 1,
      endFrame: originalMoves.length,
      framesWithCustomPause: {},
      allFrameslength: {},
      ColoredMoves: [
        {
          move: 'New Game',
          color: '',
          Index: 0,
          description: '',
          time: 1,
          descriptionColor: '#ffffff',
          highlightedSquares: {}, // Avoid nested arrays
          arrows: [], // Avoid nested arrays
        },
        ...originalMoves.map((move, index) => {
          const arrowsAndSquaresForMove = arrowsAndSquares[index] || {};
          const highlightedSquares =
            arrowsAndSquaresForMove.highlights &&
            !Array.isArray(arrowsAndSquaresForMove.highlights)
              ? arrowsAndSquaresForMove.highlights
              : {};

          const arrows = arrowsAndSquaresForMove.arrows || [];

          // Transforming arrows to an object with explicit arrow names
          const formattedArrows = arrows.reduce(
            (acc, arrow, arrowIndex) => {
              acc[`arrow${arrowIndex + 1}`] = {
                from: arrow[0],
                to: arrow[1],
                color: arrow[2],
              };
              return acc;
            },
            {},
          );

          return {
            move: move.notation,
            color: index % 2 === 0 ? 'White' : 'Black',
            time: 1,
            Index: index + 1,
            description: move.content || "",
            descriptionColor: '#ffffff',
            highlightedSquares: highlightedSquares,
            arrows: formattedArrows, // Reformatted arrows as an object
          };
        }),
      ],
      copyOfMoves: [
        'New Game',
        ...originalMoves.map((move) => move.notation),
      ],
      isFlipped: false,
      gameName: '',
      signedInUser: {
        name: currentUser.displayName || 'Anonymous',
        role: 'user',
        uid: currentUser.uid,
        videoCount: 0,
        subscriptionStatus: 'active', // Assuming premium users have active subscription
        gamesCount: 1,
      },
      pgn: pgn || '',
      videoTitle: videoTitle,
      fontType: 'Original',
      fontColor: 'green',
      aspectRatio: '9:16',
      Url: '',
      fen: gameFen, // Add FEN to the transformed data
    };

    const newCollectionName = 'chessSocialGames';
    const gameDocRef = doc(firestore, newCollectionName, gameId);

    setDoc(gameDocRef, transformedData)
      .then(() => {
        
        setSuccessMessage('Game data saved successfully!');
        setShowModal(false);
        setTimeout(() => {
          setSuccessMessage('');
          window.open(`https://www.chessclip.io/auth/login?gameId=${gameId}&uid=${currentUser.uid}&fen=${encodeURIComponent(gameFen)}`, "_blank");
        }, 1000);
      })
      .catch((error) => {
        console.error('Error saving game data:', error);
        setError('Failed to save game data. Please try again.');
        setTimeout(() => {
          setError('');
        }, 3000);
      });
  };

  // Fetch user's games
  useEffect(() => {
    const fetchUserGames = async () => {
      try {
        const userHandle = props?.user?.credentials?.handle;
        if (userHandle) {
          
          setIsLoading(true); // Assuming you have an isLoading state for games

          const gamesCollectionRef = collection(firestore, "games");
          // Query for games where creatorHandle matches the user's handle (case-insensitive)
          // Firestore v9 does not support case-insensitive queries directly on indexed fields.
          // We fetch all and filter, or rely on an exact match if handles are consistently cased.
          // For robustness, let's fetch all and filter client-side like profile.js
          // Or, if handles are reliably cased, we can use a where clause.
          // Given the info from profile.js, fetching and then filtering is safer.

          const q = query(gamesCollectionRef, orderBy("createdAt", "desc"));
          const querySnapshot = await getDocs(q);

          const allUserGames = [];
          querySnapshot.forEach((doc) => {
            allUserGames.push({ id: doc.id, ...doc.data() });
          });

          // Client-side filter for creatorHandle (case-insensitive)
          const normalizedUserHandle = userHandle.toLowerCase();
          const filteredGames = allUserGames.filter(game =>
            game.creatorHandle && game.creatorHandle.toLowerCase() === normalizedUserHandle
          );

          
          setGames(filteredGames); // Assuming setGames updates the state for the UI
          setIsLoading(false);

        } else {
          setGames([]);
          setIsLoading(false);
        }
      } catch (error) {
        console.error("Error fetching user games directly from Firestore (PremiumPortal):", error);
        setError('Failed to load your games. Please try again.'); // Assuming setError updates UI
        setGames([]);
        setIsLoading(false);
      }
    };

    fetchUserGames();
  }, [props.user]); // Dependency array based on when user data might change

  const scrollLeft = () => {
    if (scrollContainerRef.current) {
      scrollContainerRef.current.scrollBy({ left: -300, behavior: 'smooth' });
    }
  };

  const scrollRight = () => {
    if (scrollContainerRef.current) {
      scrollContainerRef.current.scrollBy({ left: 300, behavior: 'smooth' });
    }
  };

  // Modal component
  const ConversionModal = () => {
    if (!showModal) return null;

    return (
      <div style={{
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        backgroundColor: 'rgba(0, 0, 0, 0.7)',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        zIndex: 1000
      }}>
        <div style={{
          backgroundColor: '#121212',
          padding: '30px',
          borderRadius: '8px',
          maxWidth: '500px',
          width: '90%',
          border: '2px solid gold',
          boxShadow: '0 5px 15px rgba(0, 0, 0, 0.5)'
        }}>
          <h2 style={{ color: 'gold', marginBottom: '20px', textAlign: 'center' }}>Convert to Video</h2>
          
          {successMessage && (
            <div style={{ 
              color: 'green', 
              backgroundColor: 'rgba(0, 128, 0, 0.1)', 
              padding: '10px', 
              borderRadius: '4px', 
              marginBottom: '15px',
              textAlign: 'center'
            }}>
              {successMessage}
            </div>
          )}
          
          {error && (
            <div style={{ 
              color: 'red', 
              backgroundColor: 'rgba(255, 0, 0, 0.1)', 
              padding: '10px', 
              borderRadius: '4px', 
              marginBottom: '15px',
              textAlign: 'center'
            }}>
              {error}
            </div>
          )}
          
          <p style={{ color: 'white', fontSize: '18px', marginBottom: '30px', textAlign: 'center' }}>
            Would you like to make this a MP4 video?
            <br /><br />
            <span style={{ color: 'gold', fontWeight: 'bold' }}>5 videos remaining this month</span>
          </p>
          <div style={{ display: 'flex', justifyContent: 'center', gap: '20px', marginBottom: '20px' }}>
            <button
              onClick={() => setShowModal(false)}
              style={{
                padding: '10px 25px',
                backgroundColor: '#333',
                color: 'white',
                border: 'none',
                borderRadius: '4px',
                cursor: 'pointer',
                fontSize: '16px'
              }}
            >
              Cancel
            </button>
            <button
              onClick={handleConfirmConversion}
              style={{
                padding: '10px 25px',
                backgroundColor: 'gold',
                color: 'black',
                border: 'none',
                borderRadius: '4px',
                cursor: 'pointer',
                fontWeight: 'bold',
                fontSize: '16px'
              }}
            >
              Convert
            </button>

          </div>
          <div style={{
            display: 'flex',
            flexDirection: 'row',
            justifyContent: 'center',
            gap: '20px',
            marginBottom: '20px'
          }}>
            <i className="fa-brands fa-youtube" style={{ fontSize: '28px', color: 'white' }}></i>
            <i className="fa-brands fa-tiktok" style={{ fontSize: '28px', color: 'white' }}></i>
            <i className="fa-brands fa-instagram" style={{ fontSize: '28px', color: 'white' }}></i>
            <i className="fa-brands fa-facebook" style={{ fontSize: '28px', color: 'white' }}></i>
            <i className="fa-brands fa-x-twitter" style={{ fontSize: '28px', color: 'white' }}></i>
          </div>
        </div>
      </div>
    );
  };

  // Add UI tabs with gold accents
  useEffect(() => {
    setActiveTab('features');
  }, []);

  // Add listener for sidebar state changes to trigger layout adjustments
  useEffect(() => {
    // This function will force a layout adjustment when sidebar state changes
    const handleSidebarStateChange = () => {
      // Force a re-render to update the layout
      // This is a small hack to ensure containers adjust to the new sidebar width
      setTimeout(() => {
        window.dispatchEvent(new Event('resize'));
      }, 50);
    };

    // Listen for the custom sidebar state change event
    document.addEventListener('sidebarStateChanged', handleSidebarStateChange);

    // Cleanup
    return () => {
      document.removeEventListener('sidebarStateChanged', handleSidebarStateChange);
    };
  }, []);

  // Handle feedback form submission
  const handleFeedbackSubmit = async () => {
    const userHandle = props?.user?.credentials?.handle;
    const userEmail = props?.user?.credentials?.email;
    const userId = props?.user?.credentials?.userId;

    if (!userHandle || !userEmail || !userId) {
      alert("Could not identify user. Please ensure you are logged in.");
      return;
    }

    if (!feedbackMessage.trim()) {
      alert("Please enter your feedback before submitting.");
      return;
    }

    setIsSubmittingFeedback(true); // Disable button

    try {
      const feedbackCollectionRef = collection(firestore, 'feedback');
      await addDoc(feedbackCollectionRef, {
        userId: userId, // Add userId for security rules
        handle: userHandle,
        email: userEmail,
        message: feedbackMessage.trim(),
        createdAt: new Date().toISOString(),
      });

      alert("Thanks, your form has been submitted.");
      setFeedbackMessage(''); // Clear the message
      setShowFeedbackForm(false); // Hide the form

    } catch (error) {
      console.error("Error submitting feedback: ", error);
      alert("Failed to submit feedback. Please try again.");
    } finally {
       setIsSubmittingFeedback(false); // Re-enable button
    }
  };

  return (
    <div className="app-container">
      {/* Include the Mansalva font style */}
      <MansalvaFontStyle />

      {/* Features Tab Content */}
      {activeTab === 'features' && (
        <div className="explore-container main-column" style={{
          display: 'flex',
          flexDirection: 'column',
          gap: '15px',
          padding: '20px',
          paddingBottom: '20px',
          maxWidth: isSidebarCollapsed ? 'calc(100vw - 175px)' : 'calc(100vw - 250px)',
          width: '100%',
          overflow: 'auto',
          background: 'linear-gradient(to bottom, #1a1a2e 0%, #16213e 50%, #0f3460 100%)',
          borderRadius: '5px',
          boxShadow: '0 0 20px rgba(0,0,0,0.3)',
        }}>
          {/* Premium Hero Section */}
          <div className="premium-hero-section" style={{
            backgroundColor: 'rgba(0,0,0,0.3)',
            borderRadius: '12px',
            padding: '10px',
            boxShadow: '0 8px 16px rgba(0, 0, 0, 0.2)',
            border: '1px solid gold',
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
            alignItems: 'center',
            position: 'relative',
            marginBottom: ''
          }}>
            <div style={{
              color: 'gold',
              fontSize: '3.5rem',
              textShadow: '0 0 5px rgba(255, 215, 0, 0.5)',
              textAlign: 'center',
              fontWeight: 'bold',
              marginBottom: '10px',
              letterSpacing: '1px'
            }}>
              Premium Tools To Build Your Brand              <img src={crownGold} alt="Chess Logo" style={{ width: '75px', height: '75px', marginRight: '' }} />

            </div>
            <div style={{
              color: 'white',
              fontSize: '1.7rem',
              marginBottom: '15px',
              textAlign: 'center',
              maxWidth: '1000px',
              lineHeight: '1.4',
              fontStyle: 'italic'
            }}>
              Create, share, & grow your chess brand, on our platform & beyond...
            </div>

          </div>

          {/* Video Export Card */}
          <div className="video-export-card" style={{
            background: 'linear-gradient(135deg, #13274F 0%, #2A4D8F 100%)',
            borderRadius: '12px',
            padding: '20px',
            boxShadow: '0 8px 16px rgba(0,0,0,0.3)',
            border: '1px solid gold',
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
            alignItems: 'center',
            marginTop: '',
            position: 'relative'
          }}>
            <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'center', alignItems: 'center', gap: '30px' }}>
              <i className="fa-brands fa-youtube" style={{ fontSize: '4rem', color: 'gray' }}></i>
              <i className="fa-brands fa-tiktok" style={{ fontSize: '4rem', color: 'gray' }}></i>
              <button
                onClick={() => handleTabClick('transform')}
                style={{
                  padding: '20px 40px',
                  backgroundColor: '#ff0050',
                  color: 'gold',
                  border: '5px solid gold',
                  borderRadius: '8px',
                  cursor: 'pointer',
                  fontWeight: 'bold',
                  fontSize: '30px',

                  transition: 'all 0.2s ease',
                  boxShadow: '0 6px 12px rgba(0,0,0,0.5)',
                  letterSpacing: '1px'
                }}
              >
                Access Chess Video Editor
              </button>


              <i className="fa-brands fa-instagram" style={{ fontSize: '4rem', color: 'gray' }}></i>
              <i className="fa-brands fa-x-twitter" style={{ fontSize: '4rem', color: 'gray' }}></i>


            </div>

          </div>

          {/* Features Grid */}
          <div style={{
            display: 'grid',
            gridTemplateColumns: '1fr 1fr 1fr',
            gap: '25px',
            marginBottom: ''
          }}>
            {/* Premium Benefits Card */}
            <div className="premium-feature-card" style={{
              background: 'linear-gradient(135deg, #13274F 0%, #2A4D8F 50%)',
              borderRadius: '12px',
              padding: '20px',
              boxShadow: '0 8px 16px rgba(0,0,0,0.3)',
              border: '1px solid rgba(255,215,0,0.3)',
              color: 'white',
              display: 'flex',
              flexDirection: 'column',
              justifyContent: 'start',
              alignItems: 'center',
              height: '300px',
            }}>
              <h2 style={{
                fontSize: '24px',
                marginBottom: '25px',
                color: 'white',
                textAlign: 'center',
                fontWeight: 'bold',
                borderBottom: '2px solid white',
                paddingBottom: '10px',
                width: '100%'
              }}>
                Premium Users Unlock              </h2>
              <ul style={{
                listStyleType: 'disc',
                paddingLeft: '20px',
                fontSize: '1.1rem',
                lineHeight: '1.7',
                width: '100%',
                marginBottom: '15px',
                color: 'white',
                fontWeight: 'bold'
              }}>
                <li>
                  <div style={{ display: '', alignItems: 'center', marginBottom: '10px' }}>
                    <span>Full Public Stockfish Analyzsis</span>&nbsp;                   <i className="fa-solid fa-robot" style={{ color: '#58b047', marginRight: '10px', fontSize: '1.2rem' }}></i>

                  </div>
                </li>
                <li style={{ marginBottom: '10px' }}>Visibility Boost On Posts & Comments</li>
                <li style={{ marginBottom: '10px' }}>Chess-to-MP4 Vider Editor</li>
                <li>No Ads, Just Chess.</li>
              </ul>
              <div style={{ marginTop: '' }}>
                <button
                  onClick={() => {
                    // Navigate to settings with billing tab selected
                    window.location.href = '/settings?tab=billing';
                  }}
                  style={{
                    backgroundColor: 'transparent',
                    color: 'white',
                    border: '3px solid white',
                    padding: '12px 25px',
                    borderRadius: '8px',
                    cursor: 'pointer',
                    fontWeight: 'bold',
                    fontSize: '1.1rem',
                    width: '180px',
                    height: '50px',
                    transition: 'all 0.2s ease',
                    boxShadow: '0 4px 8px rgba(0,0,0,0.3)'
                  }}
                >
                  View Billing <i className="fa-solid fa-external-link" style={{ fontSize: '0.9rem', marginLeft: '5px' }}></i>
                </button>
              </div>
            </div>

            {/* Thank You Card */}
            <div className="premium-feature-card" style={{
              background: 'linear-gradient(135deg, #13274F 0%, #2A4D8F 100%)',
              borderRadius: '12px',
              padding: '5px 20px',
              boxShadow: '0 8px 16px rgba(0,0,0,0.3), 0 0 30px rgba(255,215,0,0.5)',
              border: '1px solid gold',
              color: 'white',
              display: 'flex',
              flexDirection: 'column',
              justifyContent: 'start',
              alignItems: 'center',
              height: '330px',
            }}>
              <h2 style={{
                fontSize: '30px',
                marginBottom: '5px',
                color: 'gold',
                textAlign: 'center',
                fontWeight: 'bold',
                borderBottom: '2px solid gold',
                paddingBottom: '10px',
                width: '100%',
                fontFamily: 'Mansalva, cursive'
              }}>
                ChessThread.com <img src={crownGold} alt="Chess Logo" style={{ width: '30px', height: '30px', marginRight: '' }} />
              </h2>

              <p style={{
                fontWeight: 'normal',
                textAlign: 'center',
                fontSize: '1.1rem',
                lineHeight: '1.7',
                marginBottom: '30px',
                color: 'gold',
                fontWeight: 'bold'
              }}>
                We're working hard to give you the best chess experience on the internet.
                <br /><br />
                We want to help you grow your brand
                & monetize your passion for chess.
                <br /><br />
                Thank you for supporting us.
              </p>

            </div>

            {/* Coming Soon Card */}
            <div className="premium-feature-card" style={{
              background: 'linear-gradient(135deg, #13274F 0%, #2A4D8F 50%)',
              borderRadius: '12px',
              padding: '20px',
              boxShadow: '0 8px 16px rgba(0,0,0,0.3)',
              border: '1px solid rgba(255,215,0,0.3)',
              color: 'white',
              display: 'flex',
              flexDirection: 'column',
              justifyContent: 'start',
              alignItems: 'center',
              height: '300px',
              position: 'relative'
            }}>
              {showFeedbackForm ? (
                 // Feedback Form UI
                 <>
                   <i
                     className="fa-solid fa-circle-xmark"
                     style={{
                       position: 'absolute',
                       top: '15px',
                       right: '15px',
                       fontSize: '1.8rem',
                       color: 'rgba(255, 255, 255, 0.7)',
                       cursor: 'pointer',
                       transition: 'color 0.2s ease'
                     }}
                     onClick={() => setShowFeedbackForm(false)}
                     onMouseEnter={(e) => e.target.style.color = 'white'}
                     onMouseLeave={(e) => e.target.style.color = 'rgba(255, 255, 255, 0.7)'}
                   ></i>
                   <h2 style={{
                      fontSize: '24px',
                      marginBottom: '25px',
                      color: 'white',
                      textAlign: 'center',
                      fontWeight: 'bold',
                      borderBottom: '2px solid white',
                      paddingBottom: '10px',
                      width: '100%'
                   }}>
                     Submit Feedback
                   </h2>
                   <textarea
                     value={feedbackMessage}
                     onChange={(e) => setFeedbackMessage(e.target.value)}
                     placeholder="Enter your feedback here..."
                     style={{
                       width: '95%',
                       height: '240px',
                       padding: '10px',
                       marginBottom: '30px',
                       borderRadius: '6px',
                       border: '1px solid rgba(255,215,0,0.5)',
                       backgroundColor: 'rgba(0, 0, 0, 0.2)',
                       color: 'white',
                       fontSize: '1rem',
                       resize: 'none'
                     }}
                   />
                   <div style={{ marginTop: 'auto' }}>
                     <button
                       onClick={handleFeedbackSubmit}
                       disabled={isSubmittingFeedback}
                       style={{
                         backgroundColor: isSubmittingFeedback ? '#555' : 'gold',
                         color: 'black',
                         border: '3px solid black',
                         padding: '12px 25px',
                         borderRadius: '8px',
                         cursor: isSubmittingFeedback ? 'not-allowed' : 'pointer',
                         fontWeight: 'bold',
                         fontSize: '1.1rem',
                         width: '180px',
                         height: '50px',
                         transition: 'all 0.2s ease',
                         boxShadow: '0 4px 8px rgba(0,0,0,0.3)',
                         opacity: isSubmittingFeedback ? 0.6 : 1,
                       }}
                     >
                       {isSubmittingFeedback ? 'Submitting...' : 'Submit'}
                     </button>
                   </div>
                 </>
              ) : (
                // Original Content of "Much More To Come" Card
                <>
                  <h2 style={{
                    fontSize: '24px',
                    marginBottom: '25px',
                    color: 'white',
                    textAlign: 'center',
                    fontWeight: 'bold',
                    borderBottom: '2px solid white',
                    paddingBottom: '10px',
                    width: '100%'
                  }}>
                    Much More To Come
                  </h2>
                  <ul style={{
                    listStyleType: 'disc',
                    paddingLeft: '20px',
                    fontSize: '1.1rem',
                    lineHeight: '1.7',
                    width: '100%',
                    marginBottom: '8px',
                    color: 'white',
                    fontWeight: 'bold'
                  }}>
                    <li style={{ marginBottom: '10px' }}>Direct Monetization</li>
                    <li style={{ marginBottom: '10px' }}>Enhanced Creator Tools</li>
                    <li style={{ marginBottom: '10px' }}>Advanced Analytics</li>
                    <li style={{ marginBottom: '10px' }}>Enjoy Premium At A Fixed Price.</li>
                  </ul>
                  <div style={{ marginTop: '' }}>
                    <button
                     onClick={() => setShowFeedbackForm(true)}
                     style={{
                      backgroundColor: 'gold',
                      color: 'black',
                      border: '3px solid black',
                      padding: '12px 25px',
                      borderRadius: '8px',
                      cursor: 'pointer',
                      fontWeight: 'bold',
                      fontSize: '1.1rem',
                      width: '250px',
                      height: '50px',
                      transition: 'all 0.2s ease',
                      boxShadow: '0 4px 8px rgba(0,0,0,0.3)',
                    }}
                    >Give Feedback <i className="fa-solid fa-envelope"></i></button>
                  </div>
                </>
              )}
            </div>
          </div>


        </div>
      )}

      {/* Transform Games Tab Content */}
      {activeTab === 'transform' && (
        <div className="explore-container main-column" style={{
          display: 'flex',
          flexDirection: 'column',
          gap: '25px',
         
          paddingBottom: '80px',
          maxWidth: isSidebarCollapsed ? 'calc(100vw - 155px)' : 'calc(100vw - 280px)',
          width: '100%',
        }}>
          <div className="premium-tools" style={{
            
            padding: '10px',
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'flex-start',
            alignItems: 'center',
            minHeight: '100%',
            overflow: 'visible',
            border: 'none',
            position: 'relative',
            height: '100%',
            paddingBottom: '70px'
          }}>

            {/* Return to Features button - adjusted position and styling */}
            <button
              onClick={() => handleTabClick('features')}
              style={{
                position: 'absolute',
                top: '30px',
                left: '30px',
                padding: '12px 20px',
                color: '#ff0050',
                backgroundColor: 'rgba(0,0,0,0.7)',
                border: '2px solid #ff0050',
                borderRadius: '8px',
                cursor: 'pointer',
                fontSize: '16px',
                fontWeight: 'bold',
                transition: 'all 0.2s ease',
                zIndex: 10,
                boxShadow: '0 4px 8px rgba(0,0,0,0.4)'
              }}
            >
              <i className="fa-solid fa-rotate-left"></i> Back
            </button>

            <div style={{
              color: 'gold',
              fontSize: '4rem',
              textShadow: '0 0 3px gold',
              marginBottom: '5px',
              marginTop: '0px',
              textAlign: 'center',
              fontWeight: 'bold'
            }}>
              Select A Game To Import
            </div>
            <div style={{
              color: 'white',
              fontSize: '1.4rem',
              marginBottom: '10px',
              textAlign: 'center',
              fontStyle: 'italic'
            }}>
              Click TRANSFORM To Be Redirected To Our Chess Video Editor
            </div>
            <div style={{ fontSize: '1.1rem', color: 'gray', fontStyle: 'italic', marginBottom: '20px' }}>
              (You have <span style={{ color: 'gold', fontWeight: 'bold' }}>XX</span> videos remaining this month)
            </div>

            <div style={{
              width: '100%',
              position: 'relative',
              height: '550px',
              display: 'flex',
              flexDirection: 'column',
              marginBottom: '60px'
            }}>
              <button
                style={{
                  position: 'absolute',
                  left: '0px',
                  top: '40%',
                  transform: 'translateY(-50%)',
                  zIndex: 10,
                  background: 'rgba(0,0,0,0.7)',
                  border: '2px solid #ff0050',
                  borderRadius: '50%',
                  width: '50px',
                  height: '50px',
                  cursor: 'pointer',
                  color: '#ff0050',
                  fontSize: '1.5rem',
                  boxShadow: '0 4px 8px rgba(0,0,0,0.4)'
                }}
                onClick={scrollLeft}
              >
                <i className="fa-solid fa-chevron-left"></i>
              </button>

              <div
                ref={scrollContainerRef}
                style={{
                  display: 'flex',
                  overflowX: 'auto',
                  gap: '20px',
                  padding: '10px 50px',
                  paddingBottom: '120px', // Moves transform button
                  scrollbarWidth: 'thin',
                  scrollbarColor: '#ff0050 transparent',
                  msOverflowStyle: 'none',
                  '&::-webkit-scrollbar': { display: 'none' },
                  height: '100%'
                }}
              >
                {games.length > 0 ? (
                  games.map((game) => (
                    <div key={game.id} style={{
                      position: 'relative',
                      display: 'flex',
                      flexDirection: 'column',
                      alignItems: 'center',
                      marginBottom: '0',
                      height: '100%',
                      transition: 'transform 0.3s ease',
                      ':hover': {
                        transform: 'scale(1.05)'
                      }
                    }}>
                      <GameSummary
                        gameData={game}
                        boardWidth={250}
                        onClick={() => {
                          window.open(`/games/${game.id}`, '_blank');
                        }}
                      />
                      <button
                        onClick={(e) => handleEllipsisClick(game, e)}
                        className="transform-button"
                        style={{
                          position: 'absolute',
                          bottom: '-65px',
                          left: '50%',
                          transform: 'translateX(-50%)',
                          cursor: 'pointer',
                          color: 'white',
                          fontSize: '20px',
                          display: 'flex',
                          padding: '10px 20px',
                          alignItems: 'center',
                          justifyContent: 'center',
                          borderRadius: '8px',
                          background: 'rgba(0, 0, 0, 0.8)',
                          border: '2px solid #ff0050',
                          transition: 'all 0.2s ease',
                          boxShadow: '0 4px 8px rgba(0,0,0,0.4)',
                          zIndex: 5,
                          width: '170px',
                          fontWeight: 'bold',
                          fontStyle: 'italic'
                        }}
                      >
                        TRANSFORM
                      </button>
                    </div>
                  ))
                ) : (
                  <div style={{
                    padding: '40px',
                    color: 'white',
                    fontSize: '1.4rem',
                    textAlign: 'center',
                    width: '100%',
                    background: 'rgba(0,0,0,0.6)',
                    borderRadius: '10px',
                    border: '1px solid rgba(255, 215, 0, 0.3)'
                  }}>
                    No games found. Start creating and sharing your chess content!
                  </div>
                )}
              </div>

              <button
                style={{
                  position: 'absolute',
                  right: '0px',
                  top: '40%',
                  transform: 'translateY(-50%)',
                  zIndex: 10,
                  background: 'rgba(0,0,0,0.7)',
                  border: '2px solid #ff0050',
                  borderRadius: '50%',
                  width: '50px',
                  height: '50px',
                  cursor: 'pointer',
                  color: '#ff0050',
                  fontSize: '1.5rem',
                  boxShadow: '0 4px 8px rgba(0,0,0,0.4)'
                }}
                onClick={scrollRight}
              >
                <i className="fa-solid fa-chevron-right"></i>
              </button>
            </div>





            {/* YouTube Videos Grid with iPhone overlays */}
            <div style={{
              color: 'white',
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              gap: '30px',
              width: '',
              marginTop: '0px',
              height: 'auto',
              position: 'relative'
            }}>
              {/* Left Video */}
              <div style={{
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                position: 'relative',
                height: '400px',
                width: '225px',
                overflow: 'hidden'
              }}>
                <div
                  className="youtube-player-container"
                  style={{
                    width: '204px',
                    height: '385px',
                    position: 'absolute',
                    top: '8px',
                    left: '11px',
                    zIndex: 1,
                    borderRadius: '25px',
                    overflow: 'hidden'
                  }}
                >
                  <iframe
                    src={`${YOUTUBE_VIDEOS[0]}`}
                    title="YouTube video player 1"
                    frameBorder="0"
                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                    allowFullScreen
                    style={{ transform: 'translateX(-5px)' }}
                  ></iframe>
                </div>
                <img
                  src={iPhone}
                  alt="iPhone frame"
                  style={{
                    position: 'absolute',
                    top: 0,
                    left: 0,
                    width: '225px',
                    height: '400px',
                    zIndex: 2,
                    pointerEvents: 'none'
                  }}
                />
              </div>

              {/* Center Video - Larger */}
              <div style={{
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                position: 'relative',
                height: '500px',
                width: '280px',
                overflow: 'hidden'
              }}>
                <div
                  className="youtube-player-container"
                  style={{
                    width: '257px',
                    height: '480px',
                    position: 'absolute',
                    top: '10px',
                    left: '12px',
                    zIndex: 1,
                    borderRadius: '25px',
                    overflow: 'hidden'
                  }}
                >
                  <iframe
                    src={`${YOUTUBE_VIDEOS[1]}`}
                    title="YouTube video player 2"
                    frameBorder="0"
                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                    allowFullScreen
                  ></iframe>
                </div>
                <img
                  src={iPhone}
                  alt="iPhone frame"
                  style={{
                    position: 'absolute',
                    top: 0,
                    left: 0,
                    width: '280px',
                    height: '500px',
                    zIndex: 2,
                    pointerEvents: 'none'
                  }}
                />
              </div>

              {/* Right Video */}
              <div style={{
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                position: 'relative',
                height: '400px',
                width: '225px',
                overflow: 'hidden'
              }}>
                <div
                  className="youtube-player-container"
                  style={{
                    width: '204px',
                    height: '385px',
                    position: 'absolute',
                    top: '8px',
                    left: '11px',
                    zIndex: 1,
                    borderRadius: '25px',
                    overflow: 'hidden'
                  }}
                >
                  <iframe
                    src={`${YOUTUBE_VIDEOS[2]}`}
                    title="YouTube video player 3"
                    frameBorder="0"
                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                    allowFullScreen
                    style={{ transform: 'translateX(-5px)' }}

                  ></iframe>
                </div>
                <img
                  src={iPhone}
                  alt="iPhone frame"
                  style={{
                    position: 'absolute',
                    top: 0,
                    left: 0,
                    width: '225px',
                    height: '400px',
                    zIndex: 2,
                    pointerEvents: 'none'
                  }}
                />
              </div>

            </div>
            {/* Title for video formats */}
            <div style={{
              color: 'white',
              fontSize: '2rem',
              marginBottom: '40px',
              textAlign: 'center',
              fontWeight: 'bold',
              textShadow: '0 2px 4px rgba(0,0,0,0.5)',
              paddingTop: '30px',
              paddingBottom: '30px',
              cursor: 'pointer',
            }} onClick={() => window.open('https://www.youtube.com/@TheChessRepublicYT', '_blank')}>
              Visit Our YouTube Channel <i style={{ color: 'red' }} className="fa-brands fa-youtube"></i>
            </div>
          </div>
        </div>
      )}

      {/* Render the modal */}
      <ConversionModal />
    </div>
  );
};

const mapStateToProps = (state) => ({
  data: state.data,
  user: state.user,
  isConnectedToLichess: state.user.lichessConnected,
});

export default connect(mapStateToProps)(PremiumPortal);

